import en from './en.json';
import fr from './fr.json';

export const dashboardI18n = {
  fr,
  en,
};
